import App from './app/App.vue';
import {createApp} from "vue";
import {useRouter} from "@/app/providers/AppRouter";
import i18n from "@/app/providers/i18n";
import axios from "axios";
import {createPinia} from 'pinia'
import {vuetify} from "@/app/providers/vuetify";
import {VueQueryPlugin} from '@tanstack/vue-query';
import * as Sentry from "@sentry/vue";
import {isProd} from "@/shared/lib/utils/environment";
import {setCookie} from "@/shared/lib/utils/cookie";

import {scrollOnHover} from '@/app/directives/scrollOnHover';
import RippleDirective from '@/app/directives/ripple';

import '@/app/assets/scss/main.sass';
import {gsap} from "gsap";
import {MotionPathPlugin} from "gsap/MotionPathPlugin";

const router = useRouter()

export const REQUESTS = axios.create({
    baseURL: import.meta.env.VITE_APP_API_HOST,
    headers: {
        'Access-Control-Allow-Origin': '*'
    }
});
export const request = axios.create({});

const appInstance = createApp(App)

const logPath = () => {
    setCookie('lastProjectHref', encodeURIComponent(window.location.href), 24, '/', isProd() ? '.ismet.kz' : '.i-smet.kz')
}

gsap.registerPlugin(MotionPathPlugin)

window.addEventListener('popstate', logPath);
window.addEventListener('hashchange', logPath);
window.addEventListener('load', logPath);
document.addEventListener('click', logPath);

if (isProd()) {
    Sentry.init({
        app: appInstance,
        dsn: "https://ee69571555161a40a4926e434b218d79@sentry.telecom.kz/85",
    });
}

appInstance.directive('scroll-on-hover', scrollOnHover);
appInstance.directive('ripple', RippleDirective);
appInstance
    .use(createPinia())
    .use(i18n)
    .use(router)
    .use(vuetify)
    .use(VueQueryPlugin)
    .mount('#app')
